export const SET_SHOW_UNSUPPORTED_DEVICES = 'SET_SHOW_UNSUPPORTED_DEVICES';

export const setShowUnsupportedDevices = showUnsupportedDevices => ({
  type: SET_SHOW_UNSUPPORTED_DEVICES,
  value: {showUnsupportedDevices},
});
